module.exports = __webpack_public_path__ + "static/media/bacardi.f9d429ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/marcas/bacardi.png
// module id = 941
// module chunks = 0